import {
  ACTION_GET_ORG_EXPENSE_REPORTS,
  ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_EMPTY_ORG_EXPENSE_REPORTS,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function getOrgExpenseReports(organizationId: string) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expense-reports`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function emptyOrgExpenseReports() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_ORG_EXPENSE_REPORTS,
      payload: null,
    });
  };
}

function requestStarted() {
  return {
    type: ACTION_GET_ORG_EXPENSE_REPORTS,
    payload: null,
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE,
    payload: responseJSON,
  };
}
